import { pickBy } from "lodash-es";
const __script_base__ = {
  name: 'NumberInput',
  props: {
    id: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number,
      default: 1e8
    },
    min: {
      type: Number,
      default: -1e8
    },
    step: {
      type: String,
      default: '1'
    }
  },
  computed: {
    bindProps() {
      return pickBy({
        id: this.id || null,
        readonly: this.readonly,
        required: !!this.required,
        max: this.max,
        min: this.min,
        step: this.step
      }, v => v != null); // eslint-disable-line eqeqeq
    }
  },
  methods: {
    handleChange(ev) {
      const val = +ev.target.value;
      this.$emit('change', Number.isNaN(val) ? undefined : val);
    },
    validate() {
      if (this.readonly) return; // 只读模式不需要校验

      const {
        value
      } = this;
      if (!value && this.required) throw new Error('此字段必填');
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("input", _vm._b({
    staticClass: "uc-inputbox",
    class: {
      hasError: _vm.hasError
    },
    attrs: {
      type: "number"
    },
    domProps: {
      value: _vm.value
    },
    on: {
      change: _vm.handleChange
    }
  }, "input", _vm.bindProps, false));
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/NumberInput/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);